// base_search 1 
import KeywordSearchBox from "./keyword_search_box"
import ConditionFilterModal from "./condition_filter_modal"
import AdvancedSearchModal from "./advanced_search_modal"

const SearchFilterSection = ({
    keywordPlaceholder = "關鍵字",
    defaultKeyword,
    conditionOptions = { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
    defaultConditions,
    advancedFields,
    defaultAdvancedValues,
    searchButtonText = '查詢',
    showConditionFilter = true,
    showAdvancedButton = true,
    onSearch = () => { },
    onKeywordChange = () => { },
}) => {
    const onAllSearch = (keyword) => {
        onSearch()
    }
    return (
        <div className="w-full overflow-x-auto">
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between min-w-0">
                <div className="flex flex-wrap items-center gap-2 min-w-0 w-full sm:w-auto">
                    <KeywordSearchBox
                        value={defaultKeyword}
                        placeholder={keywordPlaceholder}
                        onSearch={(value) => {
                            onAllSearch(value)
                        }}
                        searchButtonText={searchButtonText}
                        onChange={onKeywordChange}
                    />
                    {
                        showConditionFilter &&
                        <ConditionFilterModal
                            items={conditionOptions}
                            value={defaultConditions}
                        />
                    }
                    {
                        showAdvancedButton &&
                        <AdvancedSearchModal
                            items={advancedFields}
                            value={defaultAdvancedValues}
                            onFormFinish={(search_ = {}) => {
                                let search = {}
                                Object.keys(search_).forEach((key) => {
                                    if (search_[key] === undefined || search_[key] === null || search_[key] === '') {
                                    } else {
                                        search[key] = search_[key]
                                    }
                                })
                                onSearch(search)
                            }}
                        />
                    }
                </div>
            </div>
        </div>
    )
}
export default SearchFilterSection
